"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsetPermanentValueEventHandlerActivator = exports.UnsetPermanentValueEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class UnsetPermanentValueEventHandlerArgs {
    constructor(actor, key) {
        this.actor = actor;
        this.key = key;
        this.__type = EventHandlerType_1.EventHandlerType.UnsetPermanentValue;
        this.__typeName = "UnsetPermanentValue";
    }
}
exports.UnsetPermanentValueEventHandlerArgs = UnsetPermanentValueEventHandlerArgs;
let UnsetPermanentValueEventHandlerActivator = class UnsetPermanentValueEventHandlerActivator {
    activate(sequence, container, handler) {
        const { actor, key } = handler.args;
        container.unsetPermanent(actor, key);
    }
};
UnsetPermanentValueEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.UnsetPermanentValue)
], UnsetPermanentValueEventHandlerActivator);
exports.UnsetPermanentValueEventHandlerActivator = UnsetPermanentValueEventHandlerActivator;
